import services from '@/services/index';
import { PRINTOS_SELECTOR } from '@/mount-helper';
import {
  READY_STATE,
  ui,
} from '@/api';
import get from 'lodash.get';

export const READY_GATE = {
  api: 'api',
  session: 'session',
  preferences: 'preferences',
  app: 'app',
  ga: 'ga',
  //map: 'map',
  market: 'market',
  intercom: 'intercom',
  breadcrumbEvents: 'breadcrumbEvents',
};
export const POSB_READY_EVENT = 'posb-ready';

export default function bootstrapServiceFactory(services) {
  const readyGates = Object.assign({}, READY_GATE);

  let thisService = {
    readyGateCleared,
  };
  let sentEvent = false;
  return thisService;

  function readyGateCleared(gate) {
    delete readyGates[gate];
    //console.log('PrintOS Header: Ready gate cleared: ', gate, readyGates);
    if (Object.keys(readyGates).length === 0) {
      signalBlueReady();
    }
  }

  function signalBlueReady() {
    if (sentEvent) {
      return;
    }

    sentEvent = true;
    window.$printos.readyState = READY_STATE.complete;
    window.printos.blue.ui.readyState = READY_STATE.complete;
    ui.readyState = READY_STATE.complete;

    const readyCallback = get(services.window, 'printos.blue.ui.ready');
    if (typeof readyCallback === 'function') {
      //console.warn('window.printos.blue.ui.ready callback is deprecated. Listen for event "posb-ready" instead.');
      readyCallback();
    }

    let eventTarget = services.document.querySelector(PRINTOS_SELECTOR);
    if (!eventTarget) {
      eventTarget = services.document;
    }

    eventTarget.dispatchEvent(new CustomEvent(POSB_READY_EVENT, { bubbles: true, detail: ui }));

  }
}
